export const MINIMUM_CHARACTERS_SEARCH = 3;
